import * as types from '../mutation-types'
import { MultiDeleteProductFavorite } from '@/api/remind'
import { Toast, MessageBox, Indicator } from 'mint-ui'

// initial state
const state = {
  manageBtnIsOpen: false, // 收藏夹管理开关是否打开
  allChooseBtnSwitchInfo: {
    allChoosedIsOpen: false,
    allChoosedChangeNeedResetData: true
  },
  // 有效收藏夹商品列表信息
  effectiveListInfo: {
    allChoosed: false, // 是否全部选中
    chooseList: [], // 所有选中项的标识符
    dataListLength: 0 // 加载了多少数据
  },
  // 无效收藏夹商品列表信息
  ineffectiveListInfo: {
    allChoosed: false, // 是否全部选中
    chooseList: [], // 所有选中项的标识符
    dataListLength: 0 // 加载了多少数据
  }
}
// getters
const getters = {
  getManageBtnIsOpen: (state) => state.manageBtnIsOpen,
  getAllChooseBtnSwitchInfo: (state) => state.allChooseBtnSwitchInfo,
  getEffectiveListInfo: (state) => state.effectiveListInfo,
  getIneffectiveListInfo: (state) => state.ineffectiveListInfo,
  // 全选按钮是否开启
  getAllListInfoStatus: (state) => {
    // 只存在有效列表
    if (state.effectiveListInfo.chooseList.length > 0 && state.ineffectiveListInfo.dataListLength === 0) {
      // 选中了有效的商品并且无效商品为空的情况下
      // 全部选中按钮是否开启由有效的商品是否全部选中决定
      return state.effectiveListInfo.allChoosed
    }
    // 只存在无效列表
    if (state.ineffectiveListInfo.chooseList.length > 0 && state.effectiveListInfo.dataListLength === 0) {
      // 选中了无效的商品并且有效商品为空的情况下
      // 全部选中按钮是否开启由无效的商品是否全部选中决定
      return state.ineffectiveListInfo.allChoosed
    }
    // 两种皆有
    if (state.ineffectiveListInfo.chooseList.length > 0 && state.effectiveListInfo.chooseList.length > 0) {
      // 有效商品和无效商品都有选中的情况下
      // 全部选中按钮是否开启由所有商品是否全部选中决定
      return state.ineffectiveListInfo.allChoosed && state.effectiveListInfo.allChoosed
    }
    return false
  },
  chooseProductIds: (state) => {
    return [...state.effectiveListInfo.chooseList, ...state.ineffectiveListInfo.chooseList]
  }
}

// mutations
const mutations = {
  [types.SET_MANAGEBTN_IS_OPEN](state, manageBtnIsOpen) {
    state.manageBtnIsOpen = manageBtnIsOpen
    if (!manageBtnIsOpen) {
      state.effectiveListInfo.allChoosed = false
      state.effectiveListInfo.chooseList = []
      state.ineffectiveListInfo.allChoosed = false
      state.ineffectiveListInfo.chooseList = []
    }
  },
  [types.SET_EFFECTIVE_GOODS_LIST_INFO](state, effectiveListInfo) {
    state.effectiveListInfo = effectiveListInfo
  },
  [types.SET_INEFFECTIVE_LIST_INFO](state, ineffectiveListInfo) {
    state.ineffectiveListInfo = ineffectiveListInfo
  },
  [types.SET_ALL_CHOOSE_BTN_SWITCH_INFO](state, allChooseBtnSwitchInfo) {
    state.allChooseBtnSwitchInfo = allChooseBtnSwitchInfo
  }
}
// actions
const actions = {
  // 重置数据
  resetCollectionClipData({ commit }, isReFetchPage = false) {
    if (!isReFetchPage) {
      commit('SET_MANAGEBTN_IS_OPEN', false)
      commit('SET_ALL_CHOOSE_BTN_SWITCH_INFO', {
        allChoosedIsOpen: false,
        allChoosedChangeNeedResetData: false
      })
    }
    commit('SET_EFFECTIVE_GOODS_LIST_INFO', {
      allChoosed: false, // 是否全部选中
      chooseList: [], // 所有选中项的标识符
      dataListLength: 0 // 加载了多少数据
    })
    commit('SET_INEFFECTIVE_LIST_INFO', {
      allChoosed: false, // 是否全部选中
      chooseList: [], // 所有选中项的标识符
      dataListLength: 0 // 加载了多少数据
    })
  },
  // 一键删除按钮
  delBtnEvent({ state }, { callback, errorHander }) {
    let chooseProductIds = [...state.effectiveListInfo.chooseList, ...state.ineffectiveListInfo.chooseList]

    MessageBox({
      title: '提示',
      message: `当前选中${chooseProductIds.length}件商品，确认删除这些商品吗？`,
      showCancelButton: true,
      confirmButtonText: '确认',
      cancelButtonText: '我再想想',
      confirmButtonClass: 't_f23030'
    }).then((action) => {
      if (action === 'confirm') {
        Indicator.open({
          text: '加载中',
          spinnerType: 'triple-bounce'
        })
        MultiDeleteProductFavorite({ productIds: chooseProductIds })
          .then((res) => {
            Toast(res.Msg)
            callback(chooseProductIds)
            Indicator.close()
          })
          .catch((err) => {
            Indicator.close()
            Toast(err.ErrMsg)
            errorHander()
          })
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
